import { useEffect, useMemo, useRef, useState } from 'react';

//
// Adapted from the Mantine use-in-viewport hook.
// https://mantine.dev/hooks/use-in-viewport/
//
// Detects when ref is scrolled into view but, after that, wasInViewPort will
// always be true.
//

export function useWasInViewport<T extends HTMLElement = any>() {
  const ref = useRef<T>(null);
  const [wasInViewport, setWasInViewport] = useState(false);

  const observer = useMemo(() => {
    if (typeof IntersectionObserver === 'undefined') {
      return null;
    }
    return new IntersectionObserver(([entry]) =>
      setWasInViewport(oldWasInViewPort => oldWasInViewPort ?
        true :
        entry.isIntersecting)
    );
  }, [ref]);

  useEffect(() => {
    if (ref.current && observer) {
      observer.observe(ref.current);
      return () => observer.disconnect();
    }
    return () => null;
  }, []);

  return { ref, wasInViewport };
}